export const UserType: Record<string, Users.Type> = {
  Customer: 'customer',
  Admin: 'admin',
};

export const StudyDestination: Record<string, Users.StudyDestination> = {
  Domestic: 'domestic',
  Abroad: 'abroad',
};
